import i18next from 'i18next';
import common from '../common';
import FontManager from './FontManager';
import Logger from './Logger';

export default class LanguageManager {
	constructor() {
		this._currentLanguage = null;
		this.signals = {
			loaded: new P3.utils.MiniSignal(),
			changed: new P3.utils.MiniSignal(),
		};
	}

	async init() {
		await i18next.init({
			lng: common.config.language,
			debug: common.debug,
			resources: {
				[common.config.language]: {
					translation: P3.assets.json(`language_${common.config.language}`),
				},
			},
		});

		// we always need NotoSans Regular
		await FontManager.LoadFont('NotoSans-Regular', 'assets/fonts/NotoSans-Regular.woff2');

		await this.loadFonts();
	}

	async loadFonts() {
		const lang = common.i18nConfig.languageFonts[common.config.language];

		common.fonts = ['NotoSans-Regular'];

		if (lang && lang.length > 0) {
			for (let i = 0; i < lang.length; ++i) {
				const font = lang[i];
				const fontData = common.i18nConfig.fontFiles.find((f) => f.name === font);

				common.fonts.push(fontData.name);
				await FontManager.LoadFont(fontData.name, `assets/fonts/${fontData.url}`);
			}
		}

		FontManager.DeleteUnusedFonts(common.fonts);
	}

	onLanguageChanged(newLanguage) {
		Logger.log(`LanguageManager: changing language to ${newLanguage}...`);

		common.tracking.track(new P3.TrackingDataGtagEvent('change_language', {
			event_category: 'UI',
			event_type: `change_lang_${newLanguage}`,
			page_container: 'settings',
		}));

		$('html').attr('lang', newLanguage);

		P3.assets.unload(`language_${common.config.language}`);
		P3.assets.addFiles([
			{ name: `language_${newLanguage}`, url: `localisation/${newLanguage}.json` },
		], './');
		P3.assets.signals.complete.once(this.onLanguageLoaded, this);
		P3.assets.load();

		common.config.language = newLanguage;
	}

	async onLanguageLoaded() {
		Logger.log('LanguageManager: language loaded');

		if (!i18next.hasResourceBundle(common.config.language, 'translation')) {
			i18next.addResourceBundle(common.config.language, 'translation', P3.assets.json(`language_${common.config.language}`), false, false);
		}

		await i18next.changeLanguage(common.config.language);
		await this.loadFonts();

		this.signals.loaded.dispatch();
		this.signals.changed.dispatch();

		Logger.log(`LanguageManager: language changed to ${common.config.language}`);

		common.save.game.language = common.config.language;
		common.save.saveGame();
	}
}
